/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Username_AvailableInputs */

const en_onboarding_v1_username_available = /** @type {(inputs: Onboarding_V1_Username_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This username is available.`)
};

const de_onboarding_v1_username_available = /** @type {(inputs: Onboarding_V1_Username_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Benutzername ist verfügbar.`)
};

const pt_br2_onboarding_v1_username_available = /** @type {(inputs: Onboarding_V1_Username_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este nome de usuário está disponível.`)
};

const tr_onboarding_v1_username_available = /** @type {(inputs: Onboarding_V1_Username_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu kullanıcı adı kullanılabilir.`)
};

const zh_cn2_onboarding_v1_username_available = /** @type {(inputs: Onboarding_V1_Username_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此用户名可用。`)
};

const zh_hk2_onboarding_v1_username_available = /** @type {(inputs: Onboarding_V1_Username_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此用戶名稱可用。`)
};

const ko_kr2_onboarding_v1_username_available = /** @type {(inputs: Onboarding_V1_Username_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 사용자 이름을 사용할 수 있습니다.`)
};

const ru_ru2_onboarding_v1_username_available = /** @type {(inputs: Onboarding_V1_Username_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Это имя пользователя доступно.`)
};

const es_419_onboarding_v1_username_available = /** @type {(inputs: Onboarding_V1_Username_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este nombre de usuario está disponible.`)
};

/**
* | output |
* | --- |
* | "This username is available." |
*
* @param {Onboarding_V1_Username_AvailableInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_username_available = /** @type {((inputs?: Onboarding_V1_Username_AvailableInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Username_AvailableInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_username_available(inputs)
	if (locale === "de") return de_onboarding_v1_username_available(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_username_available(inputs)
	if (locale === "tr") return tr_onboarding_v1_username_available(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_username_available(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_username_available(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_username_available(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_username_available(inputs)
	return es_419_onboarding_v1_username_available(inputs)
});